.footer {
  background: #f3eddf;
  padding: 24px 20px;
  width: 100%;
  max-width: 450px;

  p {
    color: #7b766f;
    text-align: center;
    font-size: 11px;
    font-weight: 400;
    line-height: 13px;
    letter-spacing: -0.3px;
  }

  p:first-child {
    margin-bottom: 13px;
  }

  a {
    text-decoration: none;
  }
}

.footer.tariffV5 {
  background: #00af7c;

  p {
    color: #fffbf1;
    opacity: 0.8;
  }
}

// Dark mode
:global body.dark {
  :local {
    .footer {
      background: #2a2928;

      p {
        color: #8b8984;
      }
    }
  }
}

:global body.dark #secondScreenWrapper {
  :local {
    .footer {
      background-color: #181716;

      p {
        color: #fffbf1;
        opacity: 0.8;
      }
    }
  }
}
